import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type SubmitColor =
  "primary" | "secondary" | "error" | "warning" | "info" | "success";

export interface AlertDialogState {
  open: boolean;
  head: string;
  message: string;
  submitText: string;
  cancelText: string;
  submitColor: SubmitColor;
  /**
   * Callbacks are held in the store, which is why `serializableCheck` is
   * relaxed for these actions — the original app did the same.
   */
  onSubmit: (() => void) | null;
  onCancel: (() => void) | null;
  onClose: (() => void) | null;
}

const initialState: AlertDialogState = {
  open: false,
  head: "",
  message: "",
  submitText: "OK",
  cancelText: "",
  submitColor: "primary",
  onSubmit: null,
  onCancel: null,
  onClose: null,
};

const alertDialogSlice = createSlice({
  name: "alertDialog",
  initialState,
  reducers: {
    showAlertDialog(_state, action: PayloadAction<Partial<AlertDialogState>>) {
      return { ...initialState, ...action.payload, open: true };
    },
    hideAlertDialog() {
      return initialState;
    },
  },
});

export const { showAlertDialog, hideAlertDialog } = alertDialogSlice.actions;
export default alertDialogSlice.reducer;
